export default __webpack_public_path__ + "static/media/image-placeholder.3836e4b3.png";